<template lang='pug'>
  view-nav(v-if='!loading' v-bind:views='views' theme='auto')
  router-view
</template>

<style lang="scss">
@use '@printos/agnostic-styles/src/mixins' as *;
@use '@printos/agnostic-styles/src/button';
@use '@printos/agnostic-styles/src/layout';
@use '@printos/agnostic-styles/src/mixins' as *;
@use '@printos/agnostic-styles/src/dialog';
@use '@printos/agnostic-styles/src/forms';

body {
  display: flex;
  flex-direction: column;
  height: 100vh;
  font-size: 16px;
  margin: 0;
  overflow: hidden;
}

div {
  box-sizing: border-box;
}

.pros-span {
  width: 100%;
}

body[pos--theme=light] {
  color: #212121;
  background-color: #ffffff;
}

body[pos--theme=dark] {
  color: #ebebeb;
  background-color: #212121;
}

.view-container {
  @include flex-column(flex-start, flex-start);
  width: 100%;
  height: 100%;
}

.app-container {
  display: flex;
  flex-direction: row;
  flex: 1;
  overflow: hidden;
  .app-view {
    flex:1;
    display: flex;
    flex-direction: column;
  }
}

</style>

<script>
import { ViewNav } from '@printos/vue3-view-nav';
import PrintOSService from "@/services/PrintOS.service";

export default {
  components: { ViewNav },
  setup() {
    const printOS = new PrintOSService();
    return { printOS };
  },
  data() {
    return {
      loading: true,
      views: [],
    };
  },
  methods: {
    initViews() {
      this.views = [
        {
          id: 'home',
          name: this.$t('account.View_Overview'),
          description: this.$t('account.View_Overview_Description'),
          icon: {
            name: 'home'
            // svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144 144"><rect width="144" height="144" fill="none"/><path d="M116,88H104V76.46A7.33,7.33,0,0,0,96.82,69H74V56H86a8,8,0,0,0,8-8V28a8,8,0,0,0-8-8H58a8,8,0,0,0-8,8V48a8,8,0,0,0,8,8H70V69H47.18A7.33,7.33,0,0,0,40,76.46V88H28a8,8,0,0,0-8,8v20a8,8,0,0,0,8,8H56a8,8,0,0,0,8-8V96a8,8,0,0,0-8-8H44V76.46A3.33,3.33,0,0,1,47.18,73H96.82A3.33,3.33,0,0,1,100,76.46V88H88a8,8,0,0,0-8,8v20a8,8,0,0,0,8,8h28a8,8,0,0,0,8-8V96A8,8,0,0,0,116,88ZM54,48V28a4,4,0,0,1,4-4H86a4,4,0,0,1,4,4V48a4,4,0,0,1-4,4H58A4,4,0,0,1,54,48Zm6,48v20a4,4,0,0,1-4,4H28a4,4,0,0,1-4-4V96a4,4,0,0,1,4-4H56A4,4,0,0,1,60,96Zm60,20a4,4,0,0,1-4,4H88a4,4,0,0,1-4-4V96a4,4,0,0,1,4-4h28a4,4,0,0,1,4,4Z"/></svg>'
          },
        },
        {
          id: 'devices',
          name: this.$t('account.View_Devices'),
          description: this.$t('account.View_Devices_Description'),
          icon: {
            svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144 144"><rect width="144" height="144" fill="none"/><path d="M108,79a2,2,0,0,0,0-4H36a2,2,0,0,0,0,4h5v37a8,8,0,0,0,8,8H94a8,8,0,0,0,8-8V79ZM98,116a4,4,0,0,1-4,4H49a4,4,0,0,1-4-4V79H98Z"/><path d="M36,55h6a2,2,0,0,0,0-4H36a2,2,0,0,0,0,4Z"/><path d="M58,96H86a2,2,0,0,0,0-4H58a2,2,0,0,0,0,4Z"/><path d="M58,108H86a2,2,0,0,0,0-4H58a2,2,0,0,0,0,4Z"/><path d="M116,39H101V28a8,8,0,0,0-8-8H50a8,8,0,0,0-8,8V39H28a8,8,0,0,0-8,8V90a8,8,0,0,0,8,8h7a2,2,0,0,0,0-4H28a4,4,0,0,1-4-4V47a4,4,0,0,1,4-4h88a4,4,0,0,1,4,4V90a4,4,0,0,1-4,4h-7a2,2,0,0,0,0,4h7a8,8,0,0,0,8-8V47A8,8,0,0,0,116,39ZM46,28a4,4,0,0,1,4-4H93a4,4,0,0,1,4,4V39H46Z"/></svg>'
          },
          children: [{id:'agents',showInNav:false},{id:'agent',showInNav:false}]
        },
        {
          id: 'users',
          name: this.$t('account.Account_Users'),
          description: this.$t('account.View_Users_Description'),
          icon: {
            svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144 144"><rect width="144" height="144" fill="none"/><path d="M83.94,73.55A26.77,26.77,0,1,0,57.27,46.78,26.75,26.75,0,0,0,83.94,73.55Zm0-49.54A22.77,22.77,0,1,1,61.27,46.78,22.75,22.75,0,0,1,83.94,24Z"/><path d="M132.94,121.44c-5.82-23.53-24.1-37.57-48.9-37.57-24.11,0-43.3,14.75-48.9,37.57a2,2,0,0,0,3.89,1c5.14-21,22.81-34.52,45-34.52,22.84,0,39.66,12.91,45,34.53a2,2,0,0,0,1.94,1.52,2.12,2.12,0,0,0,.49-.06A2,2,0,0,0,132.94,121.44Z"/><path d="M35,71A13,13,0,1,0,22,58,13,13,0,0,0,35,71Zm0-22a9,9,0,1,1-9,9A9,9,0,0,1,35,49Z"/><path d="M50.6,84.43a2,2,0,0,0-.19-2.82c-3.93-3.43-8.8-5-15.8-5A22.28,22.28,0,0,0,13.09,92.42a2,2,0,0,0,1.33,2.49A2,2,0,0,0,15,95a2,2,0,0,0,1.91-1.42,18.31,18.31,0,0,1,17.7-12.92c6,0,10,1.22,13.17,4A2,2,0,0,0,50.6,84.43Z"/></svg>'
          }
        },
        {
          id: 'requests',
          name: this.$t('account.View_Requests'),
          description: this.$t('account.View_Requests_Description'),
          icon: {
            svg: '<?xml version="1.0" encoding="UTF-8" standalone="no"?><svg width="1024px" height="1024px" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill-rule="evenodd"><g id="invitations_icon_option_2"><g id="Group" transform="translate(0.000000, 46.000000)"><path d="M929.709638,196.076188 L1023.53355,196.076188 L1023.53355,349.465366 L929.709638,413.979655 L929.709638,196.076188 Z M102.353355,196.076188 L0,196.076188 L0,698.851829 L0.062355001,698.851829 L0,349.465366 L102.353355,419.827321 L102.353355,196.076188 Z" id="Combined-Shape"></path><path d="M511.829568,769.570178 L1023.53355,417.717239 L1023.63742,931.578839 L0.103875708,931.578839 L0,417.717239 L511.829568,769.570178 Z" id="Rectangle-209-Copy-2"></path><rect id="Rectangle-125" x="281.471725" y="170.511325" width="469.119542" height="59.6513473"></rect><rect id="Rectangle-125-Copy" x="281.471725" y="323.900503" width="469.119542" height="59.6513473"></rect><path d="M137.560528,43.2148279 L894.614186,43.2148279 L894.614186,440.752238 L937.576325,408.46441 L937.576335,0.208268832 L94.7887363,0.208268832 L94.7887363,414.429201 L137.560528,445.034587 L137.560528,43.2148279 Z" id="Path-397"></path></g></g></g></svg>'
          }
        },
        {
          id: 'planning',
          name: this.$t('account.Plan_Shift_Schedule'),
          description: this.$t('account.Plan_Shift_Schedule_Desc'),
          icon: {
            name: 'calendar-clock',
            //svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144 144"><rect width="144" height="144" fill="none"/><path d="M123.42,55.59A71.84,71.84,0,0,0,71.91,34.42,71.63,71.63,0,0,0,20.58,55.59a2,2,0,1,0,2.84,2.82,67.67,67.67,0,0,1,48.49-20,67.87,67.87,0,0,1,48.67,20A2,2,0,0,0,122,59a2,2,0,0,0,1.42-3.41Z"/><path d="M71,55A51.39,51.39,0,0,0,33.57,70.6a2,2,0,0,0,2.86,2.8A47.47,47.47,0,0,1,71,59c13.71,0,26.67,5.25,35.57,14.39a2,2,0,0,0,2.86-2.78C99.79,60.69,85.78,55,71,55Z"/><path d="M71,76A33.39,33.39,0,0,0,46.56,86.61,2,2,0,0,0,48,90a2,2,0,0,0,1.44-.61A29.09,29.09,0,0,1,71,80a32.23,32.23,0,0,1,22.59,9.42,2,2,0,0,0,2.82-2.84A36.28,36.28,0,0,0,71,76Z"/><circle cx="72" cy="104" r="6"/></svg>'
          },
          children: [{id:'schedules',showInNav:false},{id:'shifts',showInNav:false},{id:'time-off',showInNav:false}]
        },
        {
          id: 'oee',
          name: this.$t('account.OEE_Short'),
          description: this.$t('account.OEE_Description'),
          icon: {
            path: 'market/products/icons/oee.svg',
          },
          children: [{id:'oee-stations',showInNav:false},{id:'oee-user',showInNav:false}]
        },
        {
          id: 'resellers',
          name: this.$t('account.View_Resellers'),
          description: this.$t('account.View_Resellers_Description'),
          icon: {
            svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144 144"><rect width="144" height="144" fill="none"/><path d="M62.17,52.56a3.49,3.49,0,1,0-3,.18A6.79,6.79,0,0,0,54.64,58H67.36A6.69,6.69,0,0,0,62.17,52.56Z"/><path d="M87,46H73a2,2,0,0,0,0,4H87a2,2,0,0,0,0-4Z"/><path d="M83,54H73a2,2,0,0,0,0,4H83a2,2,0,0,0,0-4Z"/><path d="M105,20H39a8,8,0,0,0-8,8v88a8,8,0,0,0,8,8h66a8,8,0,0,0,8-8V28A8,8,0,0,0,105,20Zm4,96a4,4,0,0,1-4,4H39a4,4,0,0,1-4-4V28a4,4,0,0,1,4-4h66a4,4,0,0,1,4,4Z"/><path d="M93,36H51a6,6,0,0,0-6,6V62a6,6,0,0,0,6,6H93a6,6,0,0,0,6-6V42A6,6,0,0,0,93,36Zm2,26a2,2,0,0,1-2,2H51a2,2,0,0,1-2-2V42a2,2,0,0,1,2-2H93a2,2,0,0,1,2,2Z"/><path d="M93,76H51a6,6,0,0,0-6,6v20a6,6,0,0,0,6,6H93a6,6,0,0,0,6-6V82A6,6,0,0,0,93,76Zm2,26a2,2,0,0,1-2,2H51a2,2,0,0,1-2-2V82a2,2,0,0,1,2-2H93a2,2,0,0,1,2,2Z"/><path d="M85,85H59a2,2,0,0,0,0,4H85a2,2,0,0,0,0-4Z"/><path d="M78,94H59a2,2,0,0,0,0,4H78a2,2,0,0,0,0-4Z"/></svg>'
          },
        },
        {
          id: 'customers',
          name: this.$t('account.View_Customers_Category'),
          description: this.$t('account.View_Customers_Category_Description'),
          icon: {
            svg: '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n' +
              '<svg width="1024px" height="1024px" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n' +
              '    <g id="Page-1" stroke="none" stroke-width="1" fill-rule="evenodd">\n' +
              '        <g id="Reseller_icon_option_2">\n' +
              '            <g id="Group" transform="translate(42.000000, 0.000000)">\n' +
              '                <path d="M468.91024,532.189647 C652.694227,532.189647 726.005119,454.77124 726.005119,266.094823 C726.005119,77.418407 652.694227,-1.13686838e-13 468.91024,-1.13686838e-13 C285.126253,-1.13686838e-13 211.98428,76.2629084 211.98428,266.094823 C211.98428,455.926738 285.295172,532.189647 468.91024,532.189647 L468.91024,532.189647 L468.91024,532.189647 Z" id="Shape-Copy"></path>\n' +
              '                <path d="M375.712441,855.46415 L293.934417,611.05124 L0.0621923529,611.05124 L0.0621923529,875.299517 C-1.117008,915.06356 14.5157004,953.544445 43.2762815,981.67369 C72.0368593,1009.80294 111.381408,1025.09249 152.037916,1023.93917 L939.94761,1023.93917 L939.94761,759.690896 C941.027845,719.954732 925.363304,681.530684 896.624816,653.423041 C867.886326,625.315402 828.599889,609.994718 787.971887,611.05124 L652.046872,611.05124 L570.952584,853.420644 L483.453501,708.296402 L561.972521,611 L383.966014,611 L463.306812,709.314704 L375.712441,855.46415 L375.712441,855.46415 Z" id="Combined-Shape"></path>\n' +
              '            </g>\n' +
              '        </g>\n' +
              '    </g>\n' +
              '</svg>'
          },
        },
        {
          id: 'indigopsps',
          name: this.$t('account.View_Channel_PSPs'),
          description: this.$t('account.View_Channel_PSPs_Description'),
          icon: {
            svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144 144"><rect width="144" height="144" fill="none"/><path d="M62.17,52.56a3.49,3.49,0,1,0-3,.18A6.79,6.79,0,0,0,54.64,58H67.36A6.69,6.69,0,0,0,62.17,52.56Z"/><path d="M87,46H73a2,2,0,0,0,0,4H87a2,2,0,0,0,0-4Z"/><path d="M83,54H73a2,2,0,0,0,0,4H83a2,2,0,0,0,0-4Z"/><path d="M105,20H39a8,8,0,0,0-8,8v88a8,8,0,0,0,8,8h66a8,8,0,0,0,8-8V28A8,8,0,0,0,105,20Zm4,96a4,4,0,0,1-4,4H39a4,4,0,0,1-4-4V28a4,4,0,0,1,4-4h66a4,4,0,0,1,4,4Z"/><path d="M93,36H51a6,6,0,0,0-6,6V62a6,6,0,0,0,6,6H93a6,6,0,0,0,6-6V42A6,6,0,0,0,93,36Zm2,26a2,2,0,0,1-2,2H51a2,2,0,0,1-2-2V42a2,2,0,0,1,2-2H93a2,2,0,0,1,2,2Z"/><path d="M93,76H51a6,6,0,0,0-6,6v20a6,6,0,0,0,6,6H93a6,6,0,0,0,6-6V82A6,6,0,0,0,93,76Zm2,26a2,2,0,0,1-2,2H51a2,2,0,0,1-2-2V82a2,2,0,0,1,2-2H93a2,2,0,0,1,2,2Z"/><path d="M85,85H59a2,2,0,0,0,0,4H85a2,2,0,0,0,0-4Z"/><path d="M78,94H59a2,2,0,0,0,0,4H78a2,2,0,0,0,0-4Z"/></svg>'
          },
        },
        {
          id: 'history',
          name: this.$t('account.View_History'),
          description: this.$t('account.View_History_Description'),
          icon: {
            svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144 144"><rect width="144" height="144" fill="none"/><path d="M90,12a26,26,0,1,0,26,26A26,26,0,0,0,90,12Zm0,48a22,22,0,1,1,22-22A22,22,0,0,1,90,60Z"/><path d="M104,70a2,2,0,0,0-2,2v44a4,4,0,0,1-4,4H36a4,4,0,0,1-4-4V28a4,4,0,0,1,4-4H56a2,2,0,0,0,0-4H36a8,8,0,0,0-8,8v88a8,8,0,0,0,8,8H98a8,8,0,0,0,8-8V72A2,2,0,0,0,104,70Z"/><path d="M66,64H46a2,2,0,0,0,0,4H66a2,2,0,0,0,0-4Z"/><path d="M88,82H46a2,2,0,0,0,0,4H88a2,2,0,0,0,0-4Z"/><path d="M88,102H46a2,2,0,0,0,0,4H88a2,2,0,0,0,0-4Z"/><path d="M102,36h0a2,2,0,0,0-2,2A10,10,0,0,1,90,48h0a10,10,0,0,1-.23-20l-2.26,2.71a2,2,0,0,0,3.08,2.56l5-6a2,2,0,0,0-.13-2.69l-5-5a2,2,0,0,0-2.82,2.82L89.21,24A14,14,0,0,0,76,38,14,14,0,0,0,89.94,52h0a14,14,0,0,0,14-14A2,2,0,0,0,102,36Z"/></svg>'
          },
        },
        {
          id: 'connections',
          name: this.$t('account.View_Connections'),
          description: this.$t('account.View_Connections_Description'),
          icon: {
            name: 'collaboration'
          },
        },
      ];

      this.views = this.views.filter(v => {
        return this.$router.hasRoute(v.id);
      });
    },
  },
  mounted() {
    let promises = [];
    this.printOS.ui.v1.startProgress();
    return Promise.all(promises).then(() => {
    })
      .finally(() => {
        this.initViews();
        window.addEventListener('app-update-locale', this.initViews);
        this.printOS.ui.v1.endProgress();
        this.loading = false;
      });
  }
}
</script>

